<script setup lang="ts">
type Props = {
  size?: "xs" | "sm";
  rounded?: "sm" | "full";
  variant?: "primary" | "cta";
};

const {
  size = "xs",
  rounded = "sm",
  variant = "primary",
} = defineProps<Props>();
</script>

<template>
  <span
    class="py-0.5 px-1 text-center truncate text-platform-color-2 w-fit uppercase text-xs border"
    :class="[
      `md:text-${size}`,
      `rounded-${rounded}`,
      {
        'bg-platform-color-1 border border-platform-border-2 py-1':
          variant === 'primary',
        'bg-platform-neutral border-platform-neutral py-0.5': variant === 'cta',
      },
    ]"
  >
    <slot />
  </span>
</template>
